<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Registro</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <p>Por favor indique su dirección de correo electrónico y la contraseña que desee para acceder a su area de cliente, después haga clic en REGISTRARSE</p>

            <v-form ref="fmRegistro" v-model="valid" lazy-validation>
              <v-alert :value="error" type="warning">{{ error }}</v-alert>

              <v-text-field
                class="pt-3"
                v-model="email"
                prepend-icon="person"
                name="login"
                label="Correo electrónico"
                type="text"
                required
                :rules="emailRules"
              ></v-text-field>

              <v-text-field
                v-model="password"
                id="password"
                prepend-icon="lock"
                name="password"
                label="Contraseña"
                type="password"
                required
                :rules="passwordRules"
              ></v-text-field>

              <v-text-field
                v-model="password2"
                id="password2"
                prepend-icon="lock"
                name="password2"
                label="Repita la contraseña"
                type="password"
                required
                :rules="[comparePasswords, passwordRules]"
              ></v-text-field>

              <div class="pt-5">
                <router-link to="/login/signin">Ya tiene un código para activar su contraseña ?</router-link>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="reset" :disabled="authStatus==='loading'">Limpiar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="goHome">Cancelar</v-btn>
            <v-btn color="primary" @click="signup" :disabled="authStatus==='loading'">Registrarse</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
</style>

<script>
import { SIGNUP_REQUEST } from "../store/actions/auth";
import { mapGetters } from "vuex";

export default {
  name: "signup",
  computed: {
    ...mapGetters(["authStatus"]),
    comparePasswords() {
      return this.password === this.password2
        ? true
        : "La contraseña no coincide";
    }
  },
  data() {
    return {
      email: "",
      password: "",
      password2: "",

      error: "",
      valid: true,

      emailRules: [
        v => !!v || "Debe indicar la dirección de correo electrònico",
        v => /.+@.+/.test(v) || "Dirección de correo electrónico inválida"
      ],

      passwordRules: [
        v => !!v || "Debe indicar la contraseña",
        v =>
          (v && v.length >= 4) ||
          "La contraseña debe contener al menos 4 caracteres"
      ]
    };
  },
  methods: {
    signup: function() {
      this.error = "";

      if (this.$refs.fmRegistro.validate()) {
        this.$store
          .dispatch(SIGNUP_REQUEST, {
            email: this.email,
            password: this.password
          })
          .then(() => {
            this.$router.push("/login/signin");
          })
          .catch(error => {
            this.error = error;
          });
      }
    },
    reset: function() {
      this.$refs.fmRegistro.reset();
      this.error = "";
    },
    goHome: function() {
      this.$router.push("/");
    }
  }
};
</script>
